import React, { useState, useEffect } from "react";
import { styled } from '@mui/material/styles';
import {
    Box,
    Typography,
    TextField,
    Button,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    Card,
    Collapse,
    IconButton,
    Slider,
    Stack,
    Paper
} from "@mui/material";
// import Grid from "@mui/material/Grid2";
// import { toast, Bounce } from "react-toastify";
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import { SparkLineChart } from '@mui/x-charts/SparkLineChart';
// import { useTheme } from '@mui/material/styles';
// import { areaElementClasses } from '@mui/x-charts/LineChart';
import { DataGrid } from "@mui/x-data-grid";
import { formatIndianCurrency, formatIndianCurrencyCompact, formatPercentage } from '../utils/currency';

const RecentTrades = ({ data }) => {

    const recentTradesTableColumns = [
        { field: "id", headerName: "ID", width: 70 },
        // { field: "broker", headerName: "broker", width: 80 },
        { field: "instrument_id", headerName: "Instrument ID", width: 100 },
        { field: "quantity", headerName: "quantity", width: 100 },
        // { field: 'buying_signal_price', headerName: 'buying_signal_price', width: 80 },
        { field: "buying_price", headerName: "buying price", width: 150 },
        { field: "selling_price", headerName: "selling price", width: 150 },
        { field: "buy_order_timestamp", headerName: "buy timestamp", width: 150, valueGetter: (value, row) => `${value.split("T")[1].split("+")[0]}` },
        { field: "sell_order_timestamp", headerName: "sell timestamp", width: 150, valueGetter: (value, row) => `${value ? value.split("T")[1].split("+")[0] : "-"}` },
        // {
        //     headerName: 'Margin Utilised',
        //     width: 100,
        //     valueGetter: (value, row) => `${(row.quantity * row.buying_price).toFixed(2)}`,
        // },
        { field: "net_pnl", headerName: "net pnl", width: 100 },
        {
            // field: 'net_pnl',
            headerName: 'net pnl %',
            width: 100,
            valueGetter: (value, row) => `${(100 * row.net_pnl / (row.quantity * row.buying_price)).toFixed(2)}%`,
        },
        // {
        //   field: 'age',
        //   headerName: 'Age',
        //   type: 'number',
        //   width: 90,
        // },
    ];

    // Utility function to format snake_case keys
    const formatKey = (key) => {
        return key
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
    };

    // var statsRows = [];
    // Object.entries(data).map(([key, value]) => {
    //     statsRows.push({ key: formatKey(key), value: value?.toFixed(2).toLocaleString() });
    // });

    // Utility function to format currency (keeping for backward compatibility)
    function formatPrice(value) {
        return formatIndianCurrency(value);
    }

    // Utility function to format currency with compact notation
    function formatCurrency(value) {
        return formatIndianCurrencyCompact(value);
    }

    // Utility function to format percentage (unsigned)
    function formatPercentageUnsigned(value) {
        return formatPercentage(value, false);
    }

    // Utility function to format currency
    function getFontColor(value) {
        const isNegative = value < 0;
        return isNegative ? `#D32F2F` : `#4CAA50`;
    }

    const paginationModel = { page: 0, pageSize: 10 };

    return (
        <Card sx={{
            // display: { xs: 'none', md: 'block' },
            backgroundColor: 'background.paper',
            p: 2
        }}>

            <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                Recent Trades
            </Typography>
            <Paper sx={{ width: "100%" }}>
                <DataGrid rows={data} columns={recentTradesTableColumns} initialState={{ pagination: { paginationModel } }} pageSizeOptions={[5, 10]} checkboxSelection sx={{ border: 0 }} />
            </Paper>
        </Card >
    );
};

export default RecentTrades;
